import { Article, BaseArticle, RequiredArticle } from '../interfaces/Article';
import Store from '../interfaces/Store';
import update from 'immutability-helper';

// Hack that allows media module articles to have the same color as support columns
// When hack is no longer needed just remove this class and its usages
export class MediaModuleColorHack {
  private static readonly MEDIA_MODULE_PRODUCT_NUMBER = '928460';
  private static readonly SUPPORT_COLUMN_PRODUCT_NUMBER = '928010';

  static applyOnNewLightingArticle(
    requiredArticle: RequiredArticle,
    articles: BaseArticle[]
  ): void {
    if (requiredArticle.number.includes(this.MEDIA_MODULE_PRODUCT_NUMBER)) {
      const supportColumn = articles.find(article =>
        article.number.includes(this.SUPPORT_COLUMN_PRODUCT_NUMBER)
      );

      if (supportColumn) {
        requiredArticle.colors = supportColumn.colors;
      }
    }
  }

  static applyOnColorChange(state: Store, updatedArticle: Article): Store {
    if (updatedArticle.number.includes(this.SUPPORT_COLUMN_PRODUCT_NUMBER)) {
      const requiredLightingArticles = state.configuration.requiredLightingArticles.map(
        requiredArticle => {
          if (requiredArticle.number.includes(this.MEDIA_MODULE_PRODUCT_NUMBER)) {
            return { ...requiredArticle, colors: updatedArticle.colors };
          }
          return requiredArticle;
        }
      );
      return update(state, {
        configuration: {
          requiredLightingArticles: {
            $set: requiredLightingArticles
          }
        }
      });
    }
    return state;
  }
}
